// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { ProductPriceStyles } from "@conklin/Overrides/Components/ProductPrice";
import { rfqQuoteDetailsProposedDetailsGridItemStyles } from "@conklin/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItem";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { iconLinkCommonStyles } from "@conklin/XDL/Utilities";
import Plus from "@insite/mobius/Icons/Plus";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const priceStyle: TypographyPresentationProps = {
    size: 16,
    weight: fontConfig.weight.bold,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};
rfqQuoteDetailsProposedDetailsGridItemStyles.quotedPricingContainer = {
    css: css`
        max-width: 130px;
    `,
};
rfqQuoteDetailsProposedDetailsGridItemStyles.quotedPricingText = {
    size: 12,
    weight: "normal",
    css: css`
        line-height: 13px;
        text-transform: capitalize;
        padding: 0;
    `,
};
rfqQuoteDetailsProposedDetailsGridItemStyles.productPrice = {
    priceLabelText: {
        size: 12,
        weight: "normal",
        css: css`
            line-height: 13px;
            text-transform: capitalize;
            padding: 0;
            margin-bottom: 2px;
            display: inline-block;
        `,
    },
    wrapper: {
        css: css`
            margin-bottom: 5px;
        `,
    },
    price: {
        priceText: priceStyle,
        errorText: priceStyle,
        invalidPriceText: priceStyle,
    },
    invalidPriceText: priceStyle,
    quoteMessage: {
        text: priceStyle,
    },
} as ProductPriceStyles;

rfqQuoteDetailsProposedDetailsGridItemStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};
rfqQuoteDetailsProposedDetailsGridItemStyles.quotedPricingStyles = {
    row: {
        mergeCss: true,
        evenRowCss: css`
            background: transparent;
        `,
        css: css`
            border: none;
            &&& {
                padding-left: 0;
            }
        `,
    },
    quantityCell: {
        css: css`
            border: none;
            height: 18px;
            padding: 0 8px 0 0;
            vertical-align: top;
            display: flex;
            align-items: baseline;
            @media print {
                font-size: 16px;
                line-height: 16px;
            }
        `,
    },
    priceCell: {
        css: css`
            border: none;
            height: 18px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
    priceWithoutVatCell: {
        css: css`
            border: none;
            height: 30px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
    priceText: {
        size: 16,
        lineHeight: "16px",
    },
};
rfqQuoteDetailsProposedDetailsGridItemStyles.extendedUnitNetPriceText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};
rfqQuoteDetailsProposedDetailsGridItemStyles.toggleNotesLink = {
    ...iconLinkCommonStyles(Plus),
};
rfqQuoteDetailsProposedDetailsGridItemStyles.notesTextArea = {
    css: css`
        margin-top: 5px;
    `,
};
